module.exports = __webpack_public_path__ + "66dded5873a1fedd1daf2486e5ddff47.svg";